<template>
  <div class="specTable">
    <div v-if="highlights.length > 0" class="group">
      <div v-for="(item, index) in highlights" :key="index" class="col">
        <div v-if="item.title || item.description" class="title-wrap">
          <img :src="specIcon(item)" class="ic">
          <p class="text">{{ item.common_title }}</p>
          <hr>
        </div>
        <div v-if="item.title || item.description" class="text-wrap">
          <p v-if="item.title" class="fs-17 color-gray">{{ item.title }}</p>
          <p v-if="item.description" class="fs-24 bold">{{ item.description }}</p>
        </div>
      </div>
    </div>
    <div v-if="other.length > 0" class="group">
      <div v-for="(item, index) in other" :key="index" class="col">
        <div v-if="item.title || item.description" class="title-wrap">
          <img :src="specIcon(item)" alt="" class="ic">
          <p class="text">{{ item.common_title }}</p>
          <hr>
        </div>
        <div v-if="item.title || item.description" class="text-wrap">
          <p class="fs-17 color-gray">{{ item.title }}</p>
          <p class="fs-17">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "SpecsTable",
  computed: {
    ...mapGetters({
      preselect: 'build/preselected'
    }),
    build() {
      return this.preselect.build
    },
    highlights() {
      return this.build.specs.filter(item => {
        return item.highlight
      })
    },
    other() {
      return this.build.specs.filter(item => {
        return !item.highlight
      })
    },
  },
  methods: {
    specIcon(spec) {
      let specTitle = spec['common_title'].toLowerCase().replace('/', '-');
      return `/assets/images/spec_icons/${specTitle}.svg`
    }
  }
}
</script>

<style lang="scss" scoped>
.specTable {
  .group {
    display: grid;
    grid-gap: 80px 20px;
    margin-bottom: 80px;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    &:last-child {
      margin-bottom: 0;
    }

    .title-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 36px;

      .ic {
        width: 31px;
        height: 31px;
        object-fit: contain;
      }

      .text {
        white-space: nowrap;
        margin: 0 24px 0 16px;
        font-size: 20px;
        line-height: 1;
        color: #474747;
      }

      hr {
        width: 100%;
        margin: 0;
        background: #E0E0E0;
        border: none;
        height: 1px;
      }
    }

    .text-wrap {
      .fs-17.color-gray {
        margin: 0 0 12px;
      }

      .fs-24.bold {
        margin: 0;
      }

      .fs-17.bold {
        margin: 0 0 14px;
      }

      .fs-17 {
        margin: 0;
      }
    }
  }

  @media (max-width: 991px) {
    .group {
      grid-gap: 48px 20px;
      margin-bottom: 48px;

      .title-wrap {
        margin-bottom: 24px;

        .text {
          font-size: 17px;
          line-height: 17px;
          margin: 0 24px 0 12px;
        }
      }

      .text-wrap {
        .fs-24 {
          font-size: 20px;
        }

        .fs-17 {
          font-size: 14px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .group {
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 40px 20px;
      margin-bottom: 40px;

      .title-wrap {
        margin-bottom: 20px;

        .text {
          font-size: 14px;
          line-height: 1;
          margin: 0 12px 0 8px;
        }
      }

      .text-wrap {
        .fs-17 {
          font-size: 12px;
        }

        .fs-24 {
          font-size: 14px;
        }
      }
    }
  }

}
</style>
